/**
 * FeaturedEvent
 *
 * @package frontend-ui
 */
import React from 'react';
import PropTypes from 'prop-types';
import { AllHtmlEntities as Entities } from 'html-entities';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import Img from './Img';
import classNames from 'classnames';
import ReactHtmlParser from 'react-html-parser';

const decode = (new Entities()).decode;

/**
 * React Component FeaturedEvent.
 *
 * @param {Object} props Component properties.
 */
const FeaturedEvent = React.forwardRef((props, ref) => {
  const {
    className,
    data,
    badge,
    cta,
    ...forwardProps
  } = props;

  const {
    link: url,
    title: { rendered: title } = {},
    excerpt: { rendered: excerpt } = {},
    acf: {
      banner_image,
      start_date,
    } = {}
  } = data;

  const path = (new URL(url)).pathname

  return <article
    ref={ref}
    {...forwardProps}
    className={classNames(className, 'loop-event loop-event--featured loop-event loop-event--hover')}
  >
    {banner_image &&
      <div className="loop-event__img-outer embed-responsive embed-responsive-16by9">
        {badge &&
          <span className="loop-event__badge mg-badge"><span className="mg-badge__content">{badge.content}</span> <i className={`icon icon-${badge.icon ?? 'page'} mg-badge__icon`} aria-hidden="true" /></span>
        }
        <Img className='loop-event__img embed-responsive-item' {...banner_image} size="section-mobile" />
      </div>
    }
    <div className='loop-event__body'>
      <Link to={path} className='loop-event__title'>{decode(title)}</Link>
      {start_date && <Moment className='loop-event__date' format="LL @ LT">{start_date}</Moment>}
      {excerpt && <div className="loop-event__description wysiwyg-content">{ReactHtmlParser(excerpt)}</div>}
      {cta && <Link to={path} className='mt-2 btn btn-gradient btn-arrow'>{decode(cta)}</Link>}
    </div>
  </article>
})

FeaturedEvent.displayName = 'FeaturedEvent'

FeaturedEvent.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
  badge: PropTypes.object,
  cta: PropTypes.string,
}

FeaturedEvent.defaultProps = {
  className: '',
}

export default FeaturedEvent;